import { makeStyles } from '@material-ui/core/styles';

export const useWelcomeBodyWrapper = makeStyles(() => ({
  fontBold: {
    fontWeight: 600,
  }
}));